"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var MetricBaseCard_1 = require("./MetricBaseCard");
exports.SmallMetricCard = function (props) {
    var p = __assign(__assign({}, props), { banStyle: {
            fontSize: '32px',
            lineHeight: '32px',
        }, labelStyle: {
            opacity: 0.6,
            fontSize: '10px',
            color: '#000000',
            marginTop: '8px',
            paddingBottom: '8px',
            lineHeight: '10px',
        }, timeSeriesContainerStyle: {
            paddingRight: '32px',
            height: '28px',
            marginTop: '0px',
        } });
    return React.createElement(MetricBaseCard_1.MetricBaseCard, __assign({}, p));
};
//# sourceMappingURL=SmallMetricCard.js.map